import { chatPrompts } from './chatPrompts';

interface ChatMessage {
  role: 'user' | 'assistant' | 'system';
  content: string;
}

interface OpenRouterResponse {
  choices: Array<{
    message: {
      content: string;
    };
  }>;
}

const OPENROUTER_API_KEY = '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';

export const chatService = {
  async sendMessage(messages: ChatMessage[]): Promise<string> {
    const models = [
      'google/gemma-3-27b-it'
    ];

    for (const model of models) {
      try {
        console.log(`Trying model: ${model}`);
        
        const requestBody = {
          model,
          messages,
          max_tokens: 500,
          temperature: 0.7
        };

        console.log('Request body:', JSON.stringify(requestBody, null, 2));

        const response = await fetch('https://openrouter.ai/api/v1/chat/completions', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${OPENROUTER_API_KEY}`,
            'HTTP-Referer': window.location.origin,
            'X-Title': 'RenovirAI Support Chat'
          },
          body: JSON.stringify(requestBody)
        });

        console.log('Response status:', response.status);
        console.log('Response headers:', Object.fromEntries(response.headers.entries()));

        if (!response.ok) {
          const errorText = await response.text();
          console.error(`OpenRouter API Error for ${model}:`, response.status, errorText);
          continue; // Try next model
        }

        const data: OpenRouterResponse = await response.json();
        console.log('Response data:', data);
        return data.choices[0]?.message?.content || 'Sorry, I encountered an error. Please try again.';
      } catch (error) {
        console.error(`Error with model ${model}:`, error);
        continue; // Try next model
      }
    }

    // If all models fail, return a fallback response
    throw new Error('All AI models are currently unavailable. Please try again later.');
  },

  getSystemPrompt(): string {
    return chatPrompts.systemPrompt;
  },

  async testConnection(): Promise<boolean> {
    try {
      console.log('Testing OpenRouter connection...');
      const response = await fetch('https://openrouter.ai/api/v1/models', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${OPENROUTER_API_KEY}`,
          'HTTP-Referer': window.location.origin,
          'X-Title': 'RenovirAI Support Chat'
        }
      });

      console.log('Models response status:', response.status);

      if (response.ok) {
        const data = await response.json();
        console.log('Available models:', data.data?.slice(0, 5)?.map((m: any) => m.id));
        return true;
      } else {
        const errorText = await response.text();
        console.error('Failed to fetch models:', response.status, errorText);
        return false;
      }
    } catch (error) {
      console.error('Error testing connection:', error);
      return false;
    }
  }
}; 